import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";

import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../SignUp/onBoarding/job-title.css";

import { API_URL } from "../../../../../api";
import { useNavigate } from "react-router-dom";
import { useCookies } from "../../../../../hooks/useCookies";
import Sidebar from "../../../../userflow/components/sidebar/sidebar";
import { useProfile } from "../../../../userflow/components/context/ProfileContext";
import { showAlert } from "../../../../../utils/alertUtils";

const options = ["Yes", "No", "Sometimes"];

export default function Smokeupdate() {
  const { updateProfile } = useProfile();
  const [selectedSmoke, setSelectedSmoke] = useState(null);
  const [selectedDrink, setSelectedDrink] = useState(null);
  const { getCookie } = useCookies();
  const navigate = useNavigate();
  const approvalstatus = getCookie("approval");

  useEffect(() => {
    (async () => {
      const response = await fetch(`${API_URL}customer/users/smoke-drink`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getCookie("token")}`,
        },
      });

      const data = await response.json();
      if (response.ok) {
        setSelectedSmoke(options[data.smoke_id - 1]);
        setSelectedDrink(options[data.drink_id - 1]);
      }
    })();
  }, []);

  async function saveSmoke() {
    const response = await fetch(`${API_URL}customer/users/update-smoke`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("token")}`,
      },
      body: JSON.stringify({ smoke_id: options.indexOf(selectedSmoke) + 1 }),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error("Error saving have kids");
    }
  }

  async function saveAll() {
    try {
      await Promise.all([saveSmoke()]);
      await updateProfile("update");
      if (approvalstatus === "PENDING") {
        showAlert("Success", "Approval request sent!", () =>
          navigate("/user/home")
        );
      } else {
        showAlert("Success", "Successfully updated", () =>
          navigate("/updateprofile")
        );
      }
    } catch (error) {
      console.error("Error saving kids and family:", error);
    }
  }

  return (
    <Sidebar>
      <div
        style={{
          flex: "1",
          marginInline: "auto",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          overflowY: "auto",

          padding: "2rem",
        }}
      >
        <div className="job-container" style={{ overflow: "hidden" }}>
          <Container className="job-main">
            <Container className="job-content" style={{ width: "100%" }}>
              <Container className="job-details">
                <div className="your-job">
                  <Container className="job-text">
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="20" cy="20" r="18" fill="#4E1173" />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M26.5 13.5C26.5 13.2239 26.7239 13 27 13C28.3807 13 29.5 14.1193 29.5 15.5V16.2955C29.5 16.9895 29.1793 17.6086 28.6779 18.0127C29.4756 18.5519 30 19.4647 30 20.5V22C30 22.2761 29.7761 22.5 29.5 22.5C29.2239 22.5 29 22.2761 29 22V20.5C29 19.3955 28.1045 18.5 27 18.5C26.7239 18.5 26.5 18.2761 26.5 18C26.5 17.7239 26.7239 17.5 27 17.5H27.2955C27.9607 17.5 28.5 16.9607 28.5 16.2955V15.5C28.5 14.6716 27.8284 14 27 14C26.7239 14 26.5 13.7761 26.5 13.5ZM25 16.5C24.1715 16.5 23.5 17.1715 23.5 18V18.9091C23.5 19.7375 24.1715 20.4091 25 20.4091H26.5C27.3284 20.4091 28 21.0806 28 21.9091V22C28 22.2761 27.7761 22.5 27.5 22.5C27.2239 22.5 27 22.2761 27 22V21.9091C27 21.6329 26.7761 21.4091 26.5 21.4091H25C23.6193 21.4091 22.5 20.2898 22.5 18.9091V18C22.5 16.6193 23.6193 15.5 25 15.5C25.2761 15.5 25.5 15.7239 25.5 16C25.5 16.2761 25.2761 16.5 25 16.5ZM11.5 23C10.6716 23 10 23.6715 10 24.5V25.5C10 26.3285 10.6716 27 11.5 27H24.5C25.3285 27 26 26.3285 26 25.5V24.5C26 23.6715 25.3285 23 24.5 23H11.5ZM11 24.5C11 24.2239 11.2239 24 11.5 24H24.5C24.7761 24 25 24.2239 25 24.5V25.5C25 25.7761 24.7761 26 24.5 26H11.5C11.2239 26 11 25.7761 11 25.5V24.5ZM28 24C28 23.7239 27.7761 23.5 27.5 23.5C27.2239 23.5 27 23.7239 27 24V26C27 26.2761 27.2239 26.5 27.5 26.5C27.7761 26.5 28 26.2761 28 26V24ZM30 24C30 23.7239 29.7761 23.5 29.5 23.5C29.2239 23.5 29 23.7239 29 24V26C29 26.2761 29.2239 26.5 29.5 26.5C29.7761 26.5 30 26.2761 30 26V24Z"
                        fill="white"
                      />
                    </svg>

                    <p>Do you smoke?</p>
                  </Container>
                  <div
                    style={{
                      maxHeight: "50vh",
                      overflow: "auto",
                    }}
                  >
                    <div className="job-columns">
                      {options.map((option, index) => (
                        <div
                          key={index}
                          className="job-item"
                          style={{
                            padding: "1rem",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor:
                              selectedSmoke === option
                                ? "#F7ECFF"
                                : "transparent",
                          }}
                          onClick={() => setSelectedSmoke(option)}
                        >
                          {option}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Container>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  gap: "5rem",
                  marginTop: "auto",
                  marginBottom: "2rem",
                }}
              ></div>
              <div
                className="d-flex justify-content-center"
                style={{
                  position: "fixed",
                  bottom: "30px",
                  width: "100%",
                  gap: "30px",
                }}
              >
                <button
                  className="global-cancel-button"
                  onClick={() => navigate("/updateprofile")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="global-save-button"
                  onClick={saveAll}
                >
                  Save
                </button>
              </div>
            </Container>
          </Container>
        </div>
      </div>
    </Sidebar>
  );
}
